import React from "react"
import commaNumber from "comma-number"
import StringHelper from "../../common/helpers/string_helper"
import {
  ROOM_TYPE
} from "../../common/constants/classifications"
import AddressHelper from "../../common/helpers/address_helper"
import PhotoGallery from '../../search/index/photo_gallery'
import WeeklyDiscount from "../../common/components/listing_item/weekly_discount"
import "./listing_item.scss"

export default class ListingItem extends React.Component {

  getListingPathById() {
    const { id, checkin, checkout, rooms, adults } = this.props
    return routeUrlHelper.listingPath(id, {
      checkin,
      checkout,
      rooms,
      adults
    })
  }

  renderSummary() {
    const {
      property,
      propertyTypes: { property_types: types } = {},
      room_title: roomTitle,
      is_instant_booking: isInstantBooking,
      title,
      lang,
      isSP
    } = this.props

    let instant = null
    if (isInstantBooking) {
      instant = (
        <span styleName="instant-booking-mark">
          <span
            className="vs-icon-lightning-bolt-fill"
            styleName="icon"
          />
          <span>即予約</span>
        </span>
      )
    }

    const propertyType = (types && types[property.property_type]) || property.property_type

    return (
      <React.Fragment>
        <p styleName="property-type">{propertyType}</p>
        <p itemProp="name" styleName="room-type-title">
          {isSP
            ? <span>{StringHelper.getPreferredLanguageString(roomTitle, lang)}</span>
            : <a href={this.getListingPathById()} target="_blank" itemProp="mainEntityOfPage">
              {StringHelper.getPreferredLanguageString(roomTitle, lang)}
            </a>
          }
          {instant}
        </p>
        <p styleName="property-title">
          {StringHelper.getPreferredLanguageString(title, lang)}
        </p>
      </React.Fragment>
    )
  }

  renderPrice() {
    const { min_price: minPrice, isSP, adults: guests } = this.props
    const minPricePerGuest = Math.ceil(minPrice / guests)
    return (
      <div styleName="price-container">
        <div styleName="price-wrapper">
          {minPrice
            ? <React.Fragment>
              <div styleName="price">
                <span styleName="price-range" itemProp="priceRange">
                  <span>
                    <span styleName="price-unit"> &yen;</span>
                    {commaNumber(minPrice)}
                  </span>
                  <span styleName="price-unit">/泊～</span>
                </span>
                { guests >= 2
                  ? <span styleName="price-per-person">1人あたり{' '}<span>&yen;{commaNumber(minPricePerGuest)}</span>～</span>
                  : null
                }
              </div>
            </React.Fragment>
            : <React.Fragment>
              <div styleName="price">
                対象期間内に有効な料金設定がありません。
              </div>
            </React.Fragment>
          }
        </div>
        {!isSP &&
          <div styleName="btn-primary">
            <a href={this.getListingPathById()} target="_blank">空室確認</a>
          </div>
        }
      </div>
    )
  }

  renderSpecs() {
    const {
      room_type: roomType,
      room_type_localized: roomTypeLocalized,
      maximum_guests: maximumGuests,
      is_shared_bath: isSharedBath,
      bedrooms,
      bathrooms,
      beds,
      size
    } = this.props

    const _roomType = roomType === ROOM_TYPE.PRIVATE_ROOM
      ? "vs-icon-private-room" : "vs-icon-entire-home"
    return (
      <ul styleName="room-spec-icon-list">
        <li>
          <span
            className={_roomType}
            styleName="icon"
          />
          <span styleName="label">{roomTypeLocalized}</span>
        </li>
        <li>
          <span className="vs-icon-guests" styleName="icon" />
          <span styleName="label">
            定員
            <span>
              {maximumGuests}
            </span>
            名
          </span>
        </li>
        <li>
          <span className="vs-icon-bedroom" styleName="icon" />
          <span styleName="label">
            寝室
            <span>
              {bedrooms}
            </span>
            室
          </span>
        </li>
        <li>
          <span className="vs-icon-bathroom" styleName="icon" />
          <span styleName="label">
            {isSharedBath ? '共用' : ''}
            浴室
            <span>
              {bathrooms}
            </span>
            室
          </span>
        </li>
        <li>
          <span className="vs-icon-bed" styleName="icon" />
          <span styleName="label">
            寝具
            <span>
              {beds}
            </span>
            組
          </span>
        </li>
        <li>
          <span className="vs-icon-size" styleName="icon" />
          <span styleName="label">
            広さ
            <span>
              {size}&#x33a1;
            </span>
          </span>
        </li>
      </ul>
    )
  }

  renderAddress() {
    const {
      lang,
      prefecture,
      city,
      street_address: streetAddress,
      apt_name: aptName,
      distance,
      country_code: countryCode
    } = this.props

    const fullAddressText = AddressHelper.address(
      prefecture, city, streetAddress, aptName, lang, countryCode
    )
    let distanceFromDestination = null

    if (typeof distance == 'number') {
      distanceFromDestination = (
        <span styleName="distance-from-destination">
          <span>
            目的地から
            <span styleName="distance-value">
              {(distance / 1000).toFixed(1)}km
            </span>
          </span>
        </span>
      )
    }

    return (
      <div styleName="address">
        <span className="vs-icon-pin" styleName="icon" />
        <span itemProp="address">
          {fullAddressText}{distanceFromDestination}
        </span>
      </div>
    )
  }

  renderDiscount() {
    const weeklyDiscount = this.props.basic_price_setting && this.props.basic_price_setting.weekly_discount
    return weeklyDiscount ? <WeeklyDiscount discountPercentage={weeklyDiscount} /> : null
  }

  renderContent() {
    return (
      <React.Fragment>
        <div styleName="property-container">
          {this.renderSummary()}
          <hr />
          {this.renderSpecs()}
          {this.renderAddress()}
          {this.renderDiscount()}
        </div>
        {this.renderPrice()}
      </React.Fragment>
    )
  }

  render() {
    const {
      id, checkin, checkout, adults, rooms, photos,
      photos_imgix: photosImgix,
      total_photos: totalPhotos, isSP
    } = this.props

    return (
      <div
        key={id}
        styleName="listing-card"
        itemScope
        itemType="http://schema.org/LodgingBusiness"
      >
        {isSP
          ? <a
            styleName="listing-summary"
            itemProp="mainEntityOfPage"
            href={this.getListingPathById()}
            rel="noopener"
            target="_blank"
          >
            <div styleName="left-column">
              <PhotoGallery
                id={id}
                checkin={checkin}
                checkout={checkout}
                adults={adults}
                rooms={rooms}
                photos={photos}
                photos_imgix={photosImgix}
                totalPhotos={totalPhotos}
                isSP={isSP}
              />
            </div>
            <div styleName="right-column">
              {this.renderContent()}
            </div>
          </a>
          : <div
            styleName="listing-summary"
          >
            <div styleName="left-column">
              <PhotoGallery
                id={id}
                checkin={checkin}
                checkout={checkout}
                adults={adults}
                rooms={rooms}
                photos={photos}
                photos_imgix={photosImgix}
                totalPhotos={totalPhotos}
                isSP={isSP}
              />
            </div>
            <div
              styleName="right-column"
            >
              {this.renderContent()}
            </div>
          </div>
        }
      </div>
    )
  }
}
